<template>
  <div class="view-history-sterilizare instrument-modal-window"
       cy="history-modal">
    <h2>
      Istoric sterilizare
    </h2>

    <form>
      <label for="search">
        <span class="block">
          Cauta dupa dată:
        </span>
        <input id="search"
               cy="search-history"
               type="date"
               placeholder="cauta dupa data"
               @input="handleSearch" />
      </label>

      <div class="history-items">
        <ul cy="history-list">
          <li v-for="({ date, id_sterilizare }, index) in history"
              :key="index">
            <span>
              {{ format(new Date(date), 'dd MMM, yyyy') }} > {{ id_sterilizare }}
            </span>
          </li>
        </ul>
      </div>

      <div class="flex mtop25px">
        <button cy="close"
                class="m-left-auto"
                @click="handleClose">
          Close
        </button>
      </div>
    </form>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import { format } from 'date-fns';

  export default {
    name: 'ModalSterilizareHistory',
    props: {
      _id: String | Number
    },
    created () {
      this.$store.dispatch("get_history_by_id_instrument", this._id);
    },
    computed: {
      ...mapGetters(['history'])
    },
    methods: {
      format,
      handleSubmit () {},
      handleSearch (ev) {
        this.$store.commit('SEARCH_HISTORY', ev.target.value)
      },
      handleClose () {
        this.$emit('close')
      }
    }
  }
</script>

<style lang="less">
  .view-history-sterilizare {
    @media only screen and (min-width: 0) {
      .history-items {
        margin-top: 16px;
        li {
          font-size: 1.7rem;
          margin-bottom: 12px;
        }
      }
    }
  }
</style>
